export function initSearch(headerEl) {
  const box = headerEl.querySelector('#searchBox');
  const input = box ? box.querySelector('input') : null;
  const btn = headerEl.querySelector('#searchBtn');

  // Handle outside click to close search box
  document.addEventListener('click', (e) => {
    if (box && box.classList.contains('open')) {
      if (!box.contains(e.target) && (!btn || !btn.contains(e.target))) {
        box.classList.remove('open');
      }
    }
  });

  // Shortcut key (e.g. '/')
  document.addEventListener('keydown', (e) => {
    if (e.key === '/' && document.activeElement !== input && !['INPUT', 'TEXTAREA'].includes(document.activeElement?.tagName)) {
      e.preventDefault();
      if (box) {
        box.classList.add('open');
        input?.focus();
      }
    }
    if (e.key === 'Escape' && box?.classList.contains('open')) {
      box.classList.remove('open');
    }
  });
}
